import React, { useEffect, useState, useRef, useCallback, useLayoutEffect } from "react";
import { Route, withRouter } from "react-router";
import FullSidebarTheme from "../../Container/FullPageSidebar/themes";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { ThemeList, UpdateThemeStatus, UpdateThemeOrderStatus } from "../../Redux/Actions/ThemesListAction";
import { connect } from "react-redux";

// img
import Pen from "../../Assets/pen.svg";
import Handle from "../../Assets/handle.svg";

import HomeStyle from "./style";
import Loader from "../../Container/Loader";
import Modal from "../../Container/Modal";

function Themes(props) {
  const [InitialArray, setInitialArray] = useState([]);
  const [CardsArray, setCardsArray] = useState([]);
  const [OpenModal, setModal] = useState(false);
  const [Name, setName] = useState(false);
  const [UserId, setUserId] = useState(false);

  useEffect(() => {
    const data = {
      status: props.status.toString(),
    };
    props.ThemeList(data);
  }, [props.update_data, props.add_data, props.edit_data, props.status, props.location.back, props.delete_data, props.order_data]);

  useEffect(() => {
    props.clear("clear");
    props.ThemeList("");
  }, []);

  useLayoutEffect(() => {
    setTimeout(() => {
      if (props.location.method && props.location.method === "add" && props.add_data) {
        props.respType({
          type: "Theme",
          method: props.location.method,
          response: props.add_data,
        });
      }
      if (props.location.method && props.location.method === "update" && props.edit_data) {
        props.respType({
          type: "Theme",
          method: props.location.method,
          response: props.edit_data,
        });
      }
      if (props.location.method && props.location.method === "delete" && props.delete_data) {
        props.respType({
          type: "Theme",
          method: props.location.method,
          response: props.delete_data,
        });
      }
    }, 1500);
  }, [props.edit_data, props.add_data, props.delete_data]);

  useEffect(() => {
    if (props.data && props.data.data && props.data.data.data) {
      props.enabled(props.data.data.enabled);
      props.disabled(props.data.data.disabled);
      setInitialArray(props.data.data.data);
    }
  }, [props.update_data, props.add_data, props.edit_data, props.data, props.delete_data, props.order_data]);

  useEffect(() => {
    if (!props.Search) {
      setCardsArray(InitialArray);
    }
    if (props.Search.length > 2) {
      const FilteredArray = InitialArray.filter((post) => {
        const postName = post.title;
        return postName.toLowerCase().includes(props.Search.toLowerCase());
      });
      setCardsArray(FilteredArray);
    }
  }, [props.Search]);

  useEffect(() => {
    if (props.data && props.data.data && props.data.data.data) {
      setCardsArray(InitialArray);
      setTimeout(function () {
        props.clear("");
      }, 1000);
    }
  }, [props.update_data, props.add_data, props.edit_data, InitialArray, props.delete_data, props.order_data]);

  const handleModal = (e, type, name, id) => {
    e.preventDefault();
    setModal(type);
    setName(name);
    setUserId(id);
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(CardsArray);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setCardsArray(items);
    passData(items);
  };

  const passData = (items) => {
    let data = [];
    items.map((arr) => {
      let index = items.findIndex((x) => x.title === arr.title);
      let id = items.filter((x) => x.id === arr.id);
      data.push({
        id: id[0].id,
        order_number: index + 1,
      });
    });
    props.UpdateThemeOrderStatus(data);
  };

  const changePage = (items) => {
    props.history.push({
      pathname: "/dashboard/themes/edit-theme",
      state: items,
    });
  };

  const CloseModal = (e, type) => {
    e.preventDefault();
    let data;
    if (type === "enable_yes") {
      data = {
        id: UserId,
        status: 0,
      };
      props.UpdateThemeStatus(data);
    } else {
      setModal(!OpenModal);
    }

    if (type === "disable_yes") {
      data = {
        id: UserId,
        status: 1,
      };
      props.UpdateThemeStatus(data);
    } else {
      setModal(!OpenModal);
    }
  };

  const initialPath = process.env.REACT_APP_IMAGE_BASE_URL;
  return (
    <>
      {props.loading && <Loader />}
      <div className="ml-4 mr-2">
        <Route exact path={["/dashboard/themes/add-theme", "/dashboard/themes/edit-theme"]} component={FullSidebarTheme} />
        <div className="module-table-wrap w-100 themes-table table-responsive">
          <div className="table-wrap">
            <table className="table table-bordered text-center m-0 dark-blue-background">
              <thead>
                <tr>
                  <th scope="col" className="dark-light-background" />
                  <th scope="col" className="dark-light-background">
                    <span className="f-16 text-green">Id</span>
                  </th>
                  <th scope="col" className="dark-light-background">
                    <span className="f-16 text-green">Themes</span>
                  </th>
                  <th scope="col" className="dark-light-background">
                    <span className="f-16 text-green">Title</span>
                  </th>
                  <th scope="col" className="dark-light-background">
                    <span className="f-16 text-green">Status</span>
                  </th>
                  <th scope="col" className="dark-light-background">
                    <span className="f-16 text-green">Edit</span>
                  </th>
                </tr>
              </thead>
              {CardsArray.length > 0 ? (
                <DragDropContext onDragEnd={handleOnDragEnd}>
                  <Droppable droppableId="home_listing" type="listing">
                    {(provided) => (
                      <tbody className="dark-blue-background" {...provided.droppableProps} ref={provided.innerRef}>
                        {CardsArray.map((items, index) => {
                          return (
                            <Draggable key={items.id} draggableId={items.id.toString()} index={index}>
                              {(provided) => (
                                <tr ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} key={index}>
                                  <td
                                    style={
                                      items.is_edited === 0
                                        ? {
                                            width: "87px",
                                            pointerEvents: "none",
                                          }
                                        : { width: "87px" }
                                    }
                                  >
                                    <img src={Handle} alt="Handle" />
                                  </td>
                                  <td
                                    style={
                                      items.is_edited === 0
                                        ? {
                                            width: "87px",
                                            pointerEvents: "none",
                                          }
                                        : { width: "87px" }
                                    }
                                  >
                                    <span className="f-16 text-white">{items.id}</span>
                                  </td>
                                  <td
                                    style={
                                      items.is_edited === 0
                                        ? {
                                            width: "380px",
                                            pointerEvents: "none",
                                          }
                                        : { width: "380px" }
                                    }
                                  >
                                    <img
                                      src={items.header_card_image}
                                      alt="Header Card"
                                      style={{
                                        width: "300px",
                                        height: "40px",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={
                                      items.is_edited === 0
                                        ? {
                                            width: "290px",
                                            pointerEvents: "none",
                                          }
                                        : { width: "290px" }
                                    }
                                  >
                                    <span className="f-16 text-white">{items.title}</span>
                                  </td>
                                  <td
                                    style={
                                      items.is_edited === 0
                                        ? {
                                            width: "311px",
                                            pointerEvents: "none",
                                          }
                                        : { width: "311px" }
                                    }
                                  >
                                    <label className="switch mb-0">
                                      <input type="checkbox" checked={items.status === 1} onClick={(e) => handleModal(e, items.status === 1 ? "enable" : "disable", items.title, items.id)} disabled={items.is_edited === 0} onChange={(e) => handleModal(e, items.status === 1 ? "enable" : "disable", items.title, items.id)} />
                                      <span className="slider round" />
                                    </label>
                                  </td>
                                  <td
                                    style={
                                      items.is_edited === 0
                                        ? {
                                            width: "323px",
                                            pointerEvents: "none",
                                          }
                                        : { width: "323px" }
                                    }
                                  >
                                    {items.is_edited === 0 && <p className="text-white">Default theme</p>}
                                    {items.is_edited !== 0 && <img onClick={() => changePage(items)} src={Pen} alt="pen" className="ml-2 mr-2 cursor-pointer" style={items.is_edited === 0 ? { pointerEvents: "none" } : {}} />}
                                  </td>
                                </tr>
                              )}
                            </Draggable>
                          );
                        })}
                      </tbody>
                    )}
                  </Droppable>
                </DragDropContext>
              ) : (
                <tbody>
                  <tr>
                    <td colSpan="5" className="text-center border-0">
                      <p className="m-0 text-white">Nothing found</p>
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
            <HomeStyle />
          </div>
        </div>
      </div>
      {OpenModal && <Modal Name={Name} Type={OpenModal} Close={(e, type) => CloseModal(e, type)} />}
    </>
  );
}

const mapStateToProps = ({ ThemeListReducer }) => {
  const { loading, data, add_data, update_data, edit_data, delete_data, order_data } = ThemeListReducer;
  return {
    loading,
    data,
    add_data,
    update_data,
    edit_data,
    delete_data,
    order_data,
  };
};

const mapDispatchToProps = {
  ThemeList,
  UpdateThemeStatus,
  UpdateThemeOrderStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Themes));
